"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffset = void 0;
const MINUTES_IN_HOUR = 60;
const PADS = 2;
const getOffset = (date) => {
    const offset = date.getTimezoneOffset();
    const sign = offset < 0 ? '+' : '-';
    const hours = Math.abs(Math.floor(offset / MINUTES_IN_HOUR));
    const minutes = Math.abs(offset % MINUTES_IN_HOUR);
    return `${sign}${hours.toString().padStart(PADS, '0')}:${minutes.toString().padStart(PADS, '0')}`;
};
exports.getOffset = getOffset;
//# sourceMappingURL=offset.js.map